import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import {
  buildParamString,
  IAPICommonResponse,
  IAPIResponse,
} from "@mindmemobile/mm-shared-global";
import {
  IAPIPurchaseLinkGridModel,
  IAPIPurchaselinkModel,
} from "../interfaces/IAPIPurchaseLinkModel";
import {
  IAPICheckOutPurchaseModel,
  IAPIPurchaseCheckOutItemsModel,
} from "../interfaces/IAPIPurchaseModels";

class PurchaseLinkService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  createPurchaseLink(
    applicationData: IAPIPurchaselinkModel
  ): Observable<IAPIResponse<IAPICommonResponse>> {
    return this.httpService.post<IAPIResponse<IAPICommonResponse>>(
      url.createPurchaseLink,
      applicationData
    );
  }

  getPurchaseLink(
    accountId: string,
    purchaseLinkId: string | null
  ): Observable<IAPIResponse<IAPIPurchaselinkModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: purchaseLinkId,
    });

    return this.httpService.get<IAPIResponse<any>>(url.getPurchaseLink, params);
  }

  updatePurchaseLink(
    data: IAPIPurchaselinkModel
  ): Observable<IAPIResponse<boolean>> {
    return this.httpService.put<IAPIResponse<boolean>>(
      url.updatePurchaseLink,
      data
    );
  }

  getPurchaseLinksGridData(
    accountId: string,
    itemId: string,
    itemType: string,
    pageNumber: number,
    pageSize: number,
    sortColumn: string,
    searchValue = ""
  ): Observable<IAPIResponse<IAPIPurchaseLinkGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      itemId: itemId,
      itemType: itemType,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortColumn: sortColumn,
      searchValue: searchValue,
    });

    return this.httpService.get<IAPIResponse<any>>(
      url.getPurchaseLinkGridData,
      params
    );
  }

  purchaseLinkCheckoutItems(
    request: IAPICheckOutPurchaseModel
  ): Observable<IAPIResponse<IAPIPurchaseCheckOutItemsModel>> {
    return this.httpService.post<IAPIResponse<IAPIPurchaseCheckOutItemsModel>>(
      url.purchaseLinkCheckoutItems,
      request
    );
  }

  deletePurchaseLink(
    accountId: string,
    purchaseLinkId: string
  ): Observable<IAPIResponse<boolean>> {
    const request = {
      accountId: accountId,
      id: purchaseLinkId,
    };
    return this.httpService.delete<IAPIResponse<boolean>>(
      url.deletePurchaseLink,
      request
    );
  }
}

export default new PurchaseLinkService();
